// Centralized API configuration for all pages
// Use relative URLs to avoid cross-origin issues on mobile
// The deployment proxy handles routing /api/* to the backend

export const BACKEND_URL = '';  // Empty = same-origin requests
export const API = '/api';      // Relative URL - no cross-origin

// Log in development
if (process.env.NODE_ENV === 'development') {
  console.log('[CONFIG] Using relative API URLs (same-origin)');
  console.log('[CONFIG] API base:', API);
}
